<template>
  <div class="full-height">
    <div v-if="componentLoader" class="d-flex align-center justify-center full-height">
      <Loader />
    </div>
    <div v-else class="full-height">
      <div v-if="contentType" class="full-height no-scroll">
        <v-row class="py-4 impersonate-bar mb-1">
          <v-col cols="1">
            <v-btn
              icon
              @click="handleBack"
            >
              <v-icon size="32" color="third">mdi-arrow-left</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="11" class="text-center">
            <h2>{{ contentType[label.field] }}</h2>
            <div v-if="tab === 'customer_detail'" class="mt-2 flex flex-wrap">
              <v-btn
                v-for="item in impersonateButtons"
                :key="item.uuid"
                class="white--text ma-1"
                color="blue"
                :loading="loading"
                :disabled="item.disabled"
                @click="impersonateMode(item)"
              >
                Mode Impersonnate - {{ item.name }}
              </v-btn>
            </div>
          </v-col>
        </v-row>
        <v-tabs v-model="tab" vertical>
          <div
            v-for="tabItem in tabs"
            v-if="tabItem.condition !== false"
            :key="`tab_switcher_resorce_${tabItem.tabKey}`"
            class="width-270"
          >
            <v-tab v-if="canShowComponent(tabItem)" :href="`#${tabItem.tabKey}`" :class="`${tab === tabItem.tabKey ? 'red--text' : 'grey--text'}`" class="mt-4" style="justify-content: start;">
              <v-icon v-if="tabItem.icon" :class="[{'third--text': tab === tabItem.tabKey},'grey--text']">{{ tabItem.icon }}</v-icon>
              <i v-if="tabItem.customIcon" :class="[`icon ${tabItem.customIcon} ${tab === tabItem.tabKey ? 'red--text' : 'grey--text'}`]"></i>
              <span class="ml-2 break-word white-space text-start text-align-last-center">
                {{ tabItem.label }}
              </span>
            </v-tab>
          </div>

          <v-tabs-slider color="red" />

          <v-tabs-items :id="`contentTypeCalendar-${tab}`" v-model="tab" style="border-left: solid 1px #c71900;">
            <v-tab-item
              v-for="tabItem in tabs"
              :key="`tab_content_${tabItem.tabKey}`"
              :value="`${tabItem.tabKey}`"
            >
              <v-container>
                <component :is="tabItem.component" v-if="canShowComponent(tabItem)" class="ml-2" :[contentType.wtype]="contentType" :content-type="contentType" @updateContentType="updateContentType" />
              </v-container>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </div>
      <ErrorBanner v-else :message="`${ label.label } pas trouvé`" class="d-flex align-center justify-center full-height" />
    </div>
  </div>
</template>

<script>
import { computed, onBeforeUnmount, ref, watch, onBeforeMount } from '@vue/composition-api';
import { homepage, redirectToAlpha, isProd } from '../helpers/utils';
import { contentTypeSessions } from '../helpers/amplify';
import { getCustomerDetail } from '../helpers/request';

import store from '@/store';
import router from '@/router';

import ErrorBanner from '../components/common/ErrorBanner.vue';
import Loader from '../components/common/Loader.vue';
import InstructorsDetails from '../components/resourcePage/Instructor/InstructorsDetails.vue';
import InstructorRecuperation from '../components/resourcePage/Instructor/InstructorRecuperation.vue';
import HorseDetail from '../components/resourcePage/Horse/HorseDetail.vue';
import HorseMovements from '../components/resourcePage/Horse/HorseMovements.vue';
import HorseCare from '../components/resourcePage/Horse/HorseCare.vue';
import HorseSessions from '../components/resourcePage/Horse/HorseSessions.vue';
import HorseSaillies from '../components/resourcePage/Horse/HorseSaillies.vue';
import CustomerDetails from '../components/resourcePage/customer/CustomerDetails.vue';
import CustomerLicenses from '../components/resourcePage/customer/CustomerLicenses.vue';
import CustomerInsurances from '../components/resourcePage/customer/CustomerInsurances.vue';
import CustomerProducts from '../components/resourcePage/customer/CustomerProducts.vue';
import CustomerRecuperation from '../components/resourcePage/customer/CustomerRecuperation.vue';
import CustomerHorseHistory from '../components/resourcePage/customer/CustomerHorseHistory.vue';
import Planner from '../components/resourcePage/Planner.vue';
import ParticipantFalls from '@/views/ParticipantFalls.vue';
import CustomerHorses from '@/views/CustomerHorses.vue';
import CustomerHorsesSessions from '@/views/CustomerHorsesSessions.vue';

export default {
  components: {
    ErrorBanner,
    InstructorsDetails,
    InstructorRecuperation,
    HorseDetail,
    HorseMovements,
    HorseCare,
    HorseSaillies,
    Planner,
    CustomerDetails,
    CustomerLicenses,
    CustomerInsurances,
    CustomerProducts,
    CustomerRecuperation,
    Loader,
    CustomerHorseHistory,
    ParticipantFalls,
    HorseSessions,
    CustomerHorses,
    CustomerHorsesSessions
  },
  setup (_, context) {
    const route = context.root.$route;
    const loading = ref(false);
    const { uuid, type } = route.params;
    const componentLoader = ref(false);

    // const contentTypes = computed(() => store.state[`${type}s`]);

    const contentTypes = computed(() => {
      let typeToSearch = null;
      switch (type) {
        case 'collaborator':
          typeToSearch = 'instructors';
          break;
        default:
          typeToSearch = `${type}s`;
      }
      return store.state[typeToSearch];
    });

    // const contentType = computed(() => contentTypes.value.find(s => s.uuid === uuid));

    const contentType = computed({
      get () {
        return contentTypes.value.find(s => s.uuid === uuid);
      },
      // setter
      set (newValue) {
        // contentType.value = newValue;
      }
    });

    const labels = ref([
      { type: 'horse', label: 'Cheval', field: 'horse_name' },
      { type: 'place', label: 'Lieu de Pratique', field: 'place_name' },
      { type: 'collaborator', label: 'Instructeurs', field: 'fullname' },
      { type: 'customer', label: 'Customer', field: 'fullname' }
    ]);

    const label = computed(() => labels.value.find(l => l.type === type));

    const tab = ref(null);

    const tabs = ref([
      { tabKey: 'planner', icon: 'mdi-calendar', label: 'Agenda', component: 'Planner' },
      { tabKey: 'horse_information', icon: 'mdi-account-multiple', label: 'Informations du Cheval', component: 'HorseDetail', contentType: 'horse' },
      { tabKey: 'horse_movements', icon: 'mdi-format-horizontal-align-center', label: 'Entrées / sorties', component: 'HorseMovements', contentType: 'horse' },
      { tabKey: 'horse_sessions', icon: 'mdi-horse', label: 'Activité des chevaux', component: 'HorseSessions', contentType: 'horse' },
      { tabKey: 'horse_care', icon: 'mdi-bottle-tonic-plus', label: 'Soins', component: 'HorseCare', contentType: 'horse' },
      { tabKey: 'horse_saillie', icon: 'mdi-map-marker', label: 'Saillie', component: 'HorseSaillies', contentType: 'horse' },
      { tabKey: 'instructor_detail', icon: 'mdi-account-multiple', label: 'Détail de l\'instructeur', component: 'InstructorsDetails', contentType: 'collaborator' },
      { tabKey: 'instructor_recuperation', icon: 'mdi-recycle', label: 'récupération', component: 'InstructorRecuperation', contentType: 'collaborator' },
      { tabKey: 'customer_detail', icon: 'mdi-account-multiple', label: 'Détail du cavalier', component: 'CustomerDetails', contentType: 'customer' },
      { tabKey: 'customer_presence', icon: 'mdi-recycle', label: 'Présences Absences Récupération', component: 'CustomerRecuperation', contentType: 'customer' },
      { tabKey: 'customer_licences', icon: 'mdi-account-multiple', label: 'Licences', component: 'CustomerLicenses', contentType: 'customer' },
      { tabKey: 'customer_insurances', icon: 'mdi-account-multiple', label: 'Assurances', component: 'CustomerInsurances', contentType: 'customer' },
      { tabKey: 'customer_Products', icon: 'mdi-recycle', label: 'Affectation de produits', component: 'CustomerProducts', contentType: 'customer' },
      { tabKey: 'customer_horse:history', icon: 'mdi-horse-human', label: 'Historique de monte', component: 'CustomerHorseHistory', contentType: 'customer' },
      { tabKey: 'customer_fall', icon: 'mdi-account-injury', label: 'Historique de chutes', component: 'ParticipantFalls', contentType: 'customer' },
      { tabKey: 'customer_horses', icon: 'mdi-horse', label: 'Mes Chevaux', component: 'CustomerHorses', contentType: 'customer' },
      { tabKey: 'customer_horse:planning', icon: 'mdi-horse', label: 'Planification des mes chevaux', component: 'CustomerHorsesSessions', contentType: 'customer', condition: !isProd }
    ]);

    const getSessionsArray = async () => contentTypeSessions(contentType.value, null, null, 500);

    const lazyLoadData = async () => {
      switch (type) {
        case 'collaborator':
          if (!store.state.isLazyLoaded.instructors) {
            await store.dispatch('getInstructors');
          }
          break;
        case 'horse':
          if (!store.state.isLazyLoaded.horses) {
            await store.dispatch('getHorses');
          }
          break;
        default:
          break;
      }
    }

    onBeforeMount(async () => {
      componentLoader.value = true;

      await lazyLoadData();

      const sessions = await getSessionsArray();
      store.commit('setContentTypeSessions', sessions);
      if (route.params.type && route.params.type === 'customer') {
        const response = await getCustomerDetail(route.params.uuid);
        // TODO: computed setter
        contentType.value = response.data;
        const { customers } = store.state;
        const uuids = customers.map(c => c.uuid);

        if (response && response.data && response.data.uuid) {
          if (!uuids.includes(response.data.uuid)) {
            customers.push({
              ...response.data,
              fullname: `${response.data.firstname} ${response.data.lastname}`
            });
            store.commit('setCustomers', customers);
          }
        }
      }
      componentLoader.value = false;
    });

    const updateContentType = updatedContentType => {
      const auxiliarContentTypes = [...contentTypes.value];
      auxiliarContentTypes[contentTypes.value.findIndex(c => c.uuid === updatedContentType.uuid)] = updatedContentType;
      store.commit('setCustomers', auxiliarContentTypes);
    };

    watch(contentType, async () => {
      const sessions = await getSessionsArray();
      store.commit('setContentTypeSessions', sessions);
    });

    onBeforeUnmount(() => {
      store.commit('setContentTypeSessions', []);
    });

    const impersonateMode = async impersonateCustomer => {
      loading.value = true;
      await redirectToAlpha(impersonateCustomer);
      loading.value = false;
    };

    const canShowComponent = tabItem => (!tabItem.contentType ? true : tabItem.component && tabItem.contentType === contentType.value.wtype);

    const handleBack = () => {
      if (route.query && route.query.returnTo) {
        router.push({ name: route.query.returnTo });
        return;
      }
      homepage();
    };

    const impersonateButtons = computed(() => {
      if (tab.value !== 'customer_detail') {
        return [];
      }

      const impersonateAccounts = [];

      // if no contacts_from, show its own impersonate button enable (if digital account) or disable (no digital account)
      if (!contentType?.value?.contacts_from?.length || (contentType.value.digital_account)) {
        impersonateAccounts.push({
          uuid: contentType.value.uuid,
          disabled: !contentType.value.digital_account,
          name: `${contentType.value.firstname} ${contentType.value.lastname}`,
          digital_account: contentType.value.digital_account
        });
      }

      (contentType?.value?.contacts_from || []).map(contactFrom => {
        impersonateAccounts.push({
          uuid: contactFrom.uuid,
          disabled: !contactFrom.digital_account,
          name: `${contactFrom.firstname} ${contactFrom.lastname}`,
          digital_account: contactFrom.digital_account
        });
      });

      return impersonateAccounts;
    });

    return { impersonateButtons, handleBack, updateContentType, impersonateMode, componentLoader, canShowComponent, tab, tabs, loading, homepage, uuid, type, contentType, label };
  }
};
</script>

<style scoped>
  .impersonate-bar {
    position: sticky;
    top: 0;
    z-index: 2;
    background: white;
  }

  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
    overflow: hidden;
  }

  li {
    float: left;
  }

  li > a{
    color: black;
  }
</style>
